import { customRef } from 'vue';

export function getMabiNameColor(name: string): string {
    if (!name?.length) {
        return '#808080';
    }

    // https://mabinoger.com/color_sim.htm
    const colCalc = (i: number) => (i * 101) % 97 + 159;

    // if (name.length < 3) {
    //     return '#808080';
    // }

    const ccolor = [0, 0, 0];
    // R = (ASCII Char 1,4,7,10
    // G = (ASCII Char 2,5,8,11
    // B = (ASCII Char 3,6,9,12
    //                          * 101) mod 97) + 159
    for (let i = 0; i < name.length; i++) {
        ccolor[i % 3] += name.charCodeAt(i);
    }
    ccolor[0] = colCalc(ccolor[0]);
    ccolor[1] = colCalc(ccolor[1]);
    ccolor[2] = colCalc(ccolor[2]);

    return '#' + ccolor.map(v => v.toString(16).padStart(2, '0')).join('');
}

export const playerPalette = [
    '#FF6B6B', '#4ECDC4', '#FFE66D', '#1A535C', '#F7FFF7',
    '#FF9F1C', '#2EC4B6', '#E71D36', '#7B2CBF', '#FDFFFC',
    '#9D4EDD', '#F15BB5', '#00F5D4', '#FEE440', '#00BBF9',
    '#F26419', '#33658A', '#86BBD8', '#F6AE2D', '#2F4858'
];
export const skillPalette = ['#D7CCC8', '#F8BBD0', '#BBDEFB', '#F0F4C3', '#FFE0B2', '#CFD8DC']; // Brown, Pink, Blue, Lime, Orange, BlueGrey

export function getPlayerColor(idx: number): string {
    return playerPalette[idx % playerPalette.length];
}

export function getSkillColor(idx: number): string {
    return skillPalette[idx % skillPalette.length];
}

export function hexToRgba(hex: string, alpha: number): string {
    const r = parseInt(hex.slice(1, 3), 16);
    const g = parseInt(hex.slice(3, 5), 16);
    const b = parseInt(hex.slice(5, 7), 16);
    return `rgba(${r}, ${g}, ${b}, ${alpha})`;
}

export function formatNumber(num: number): string {
    return num.toLocaleString();
}

export function formatDuration(sec: number): string {
    const totalMs = Math.floor(sec * 1000);
    const m = Math.floor(totalMs / 60000);
    const s = Math.floor((totalMs % 60000) / 1000);
    const ms = totalMs % 1000;
    return `${m}:${s.toString().padStart(2, '0')}.${ms.toString().padStart(3, '0')}`;
}

export const resourceBaseUrl = 'https://whatisthismeme.github.io/funnyresources';

export function getSkillIconUrl(skillId: number, region: string): string {
    return `${resourceBaseUrl}/res/skillimage/${region}/${skillId}.png`;
}

export function getStatusIconUrl(statusId: number): string {
    return `${resourceBaseUrl}/res/status/${statusId}.png`;
}

export interface IUpdateCallback {
    setUpdateCallback(track: () => void, trigger: () => void): void;
}

export function CustomReactive<T extends IUpdateCallback>(value: T): T {
    const state = customRef<T>((track, trigger) => {
        value.setUpdateCallback(track, trigger);

        return {
            get() {
                track();
                return value;
            },
            set(newValue: T) {
                value = newValue;
                trigger();
            },
        };
    });

    return state.value;
}